module.exports = __webpack_public_path__ + "13ea68dd697ae974.png";